<!-- Hero Section with Modern Glassmorphism Design -->
<section class="hero-section position-relative overflow-hidden" style="min-height: 100vh; background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 50%, #ffffff 100%);">
    <!-- Animated Background Elements -->
    <div class="position-absolute w-100 h-100" style="top: 0; left: 0; z-index: 1;">
        <div class="floating-shape" style="position: absolute; top: 10%; left: 5%; width: 200px; height: 200px; background: linear-gradient(45deg, rgba(82, 220, 183, 0.1), rgba(163, 223, 255, 0.1)); border-radius: 50%; animation: float 6s ease-in-out infinite;"></div>
        <div class="floating-shape" style="position: absolute; top: 60%; right: 10%; width: 150px; height: 150px; background: linear-gradient(45deg, rgba(163, 223, 255, 0.1), rgba(82, 220, 183, 0.1)); border-radius: 50%; animation: float 8s ease-in-out infinite reverse;"></div>
        <div class="floating-shape" style="position: absolute; bottom: 20%; left: 15%; width: 100px; height: 100px; background: linear-gradient(45deg, rgba(82, 220, 183, 0.15), rgba(255, 255, 255, 0.1)); border-radius: 50%; animation: float 10s ease-in-out infinite;"></div>
    </div>
    
    <div class="container position-relative" style="z-index: 2; padding-top: 0px; padding-bottom: 80px;">
        <div class="row align-items-center min-vh-100">
            <div class="col-lg-6 text-center text-lg-start mb-5 mb-lg-0">
                <!-- Badge -->
                <div class="mb-4">
                    <span class="badge rounded-pill px-4 py-2" style="background: rgba(255, 255, 255, 0.2); backdrop-filter: blur(10px); border: 1px solid rgba(255, 255, 255, 0.3); color: var(--dark-color); font-size: 0.9rem; letter-spacing: 1px; font-weight: 500;">
                        🚗 Comparte • Ahorra • Conecta
                    </span>
                </div>
                
                <!-- Main Heading -->
                <h1 class="display-2 fw-bold mb-4" style="color: var(--dark-color); line-height: 1.1; font-size: clamp(2.5rem, 5vw, 4rem);">
                    Tú viaje <span style="color:white">compartido</span>,<br>
                    Tú impacto <span style="color: white">positivo</span>
                </h1>
                
                <!-- Description -->
                <p class="lead mb-5" style="color: var(--dark-color); opacity: 0.8; font-size: 1.25rem; max-width: 500px; line-height: 1.6;">
                    RoutiGo es la app de carpool (transporte colaborativo), que te conecta con personas de confianza para compartir viajes, crear comunidad, reducir costos y cuidar el planeta; conductor o pasajero, moverse juntos es mejor!!
                </p>
                
                <!-- CTA Buttons -->
                <!-- <div class="d-flex flex-column flex-sm-row gap-3 justify-content-center justify-content-lg-start mb-5">
                    <a [routerLink]="['/']" [fragment]="'footer-subscribe-form'" (click)="scrollToSubscribe($event)" class="btn btn-lg px-5 py-3 rounded-pill fw-bold" style="background: var(--primary-color); color: white; border: none; box-shadow: 0 8px 25px rgba(82, 220, 183, 0.3); transition: all 0.3s ease; font-size: 1.1rem;">
                        Comenzar Ahora
                    </a>
                </div> -->

                <!-- Coming Soon Card - Modern Glassmorphism Design -->
                <div class="col-12 d-flex justify-content-center my-5">
                    <div class="card border-0 shadow-lg text-center p-4 px-5" style="
                        background: white;
                        backdrop-filter: blur(18px);
                        border-radius: 32px;
                        max-width: 420px;
                        box-shadow: 0 16px 48px rgba(82,220,183,0.10), 0 2px 8px rgba(163,223,255,0.08);
                        border: 1.5px solid rgba(255,255,255,0.25);
                        ">
                        <div class="d-flex flex-column align-items-center mb-3">
                            <div style="
                                background: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
                                width: 64px; height: 64px;
                                border-radius: 20px;
                                display: flex; align-items: center; justify-content: center;
                                box-shadow: 0 4px 24px rgba(82,220,183,0.18);
                                margin-bottom: 10px;
                            ">
                                <span style="font-size: 2.2rem; color: #fff;">🚀</span>
                            </div>
                            <h2 class="display-6 fw-bold mb-2" style="
                                color: var(--primary-color);
                                letter-spacing: 2px;
                                font-size: 2rem;
                                text-shadow: 0 2px 8px rgba(82,220,183,0.08);
                            ">
                                ¡Muy pronto!
                            </h2>
                        </div>
                        <div class="d-flex justify-content-center gap-3 flex-wrap mb-3">
                            <a href="https://play.google.com/store/apps/details?id=co.com.routigo.app" target="_blank" class="text-decoration-none" style="filter: grayscale(0.3) brightness(0.98); transition: filter 0.3s;">
                                <img src="../../../../assets/img/play_store_placeholder.png" alt="Google Play" class="app-badge" style="
                                    height: 54px; width: auto;
                                    border-radius: 14px;
                                    box-shadow: 0 6px 20px rgba(82,220,183,0.10);
                                    border: 1.5px solid rgba(82,220,183,0.10);
                                    background: rgba(255,255,255,0.7);
                                    transition: transform 0.3s, box-shadow 0.3s, filter 0.3s;
                                ">
                            </a>
                            <a href=" https://apps.apple.com/co/app/routigo/id6755113975" target="_blank" class="text-decoration-none" style="filter: grayscale(0.3) brightness(0.98); transition: filter 0.3s;">
                                <img src="../../../../assets/img/app_store_placeholder.png" alt="App Store" class="app-badge" style="
                                    height: 54px; width: auto;
                                    border-radius: 14px;
                                    box-shadow: 0 6px 20px rgba(163,223,255,0.10);
                                    border: 1.5px solid rgba(163,223,255,0.10);
                                    background: rgba(255,255,255,0.7);
                                    transition: transform 0.3s, box-shadow 0.3s, filter 0.3s;
                                ">
                            </a>
                        </div>
                        <small style="
                            color: var(--dark-color);
                            opacity: 0.75;
                            font-size: 1.05rem;
                            letter-spacing: 0.5px;
                            text-shadow: 0 1px 4px rgba(163,223,255,0.06);
                        ">
                            Disponible próximamente en tu tienda favorita
                        </small>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-6 d-flex justify-content-center align-items-center">
                <div class="position-relative">
                    <!-- Glassmorphism Card Background -->
                    <div class="position-absolute w-100 h-100" style="background: rgba(255, 255, 255, 0.15); backdrop-filter: blur(20px); border-radius: 40px; border: 1px solid rgba(255, 255, 255, 0.2); box-shadow: 0 20px 60px rgba(0,0,0,0.1);"></div>
                    
                    <!-- Phone Mockup -->
                    <div class="position-relative p-4">
                        <img src="../../../../assets/img/app_placeholder.png" alt="RoutiGo App" class="img-fluid" style="max-height: 500px; width: auto; border-radius: 35px; box-shadow: 0 25px 80px rgba(0,0,0,0.15); animation: phoneFloat 6s ease-in-out infinite;">
                    </div>
                    
                    <!-- Floating Feature Cards -->
                    <div class="position-absolute" style="top: 20%; left: -60px; z-index: 3;">
                        <div class="card border-0 shadow-lg" style="width: 160px; background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(15px); border-radius: 20px; animation: float 8s ease-in-out infinite;">
                            <div class="card-body p-3 text-center">
                                <div class="mb-2" style="font-size: 2rem;">🚗</div>
                                <small class="fw-bold" style="color: var(--dark-color);">Comparte o busca tu trayecto</small>
                            </div>
                        </div>
                    </div>
                    
                    <div class="position-absolute" style="bottom: 30%; right: -50px; z-index: 3;">
                        <div class="card border-0 shadow-lg" style="width: 140px; background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(15px); border-radius: 20px; animation: float 6s ease-in-out infinite reverse;">
                            <div class="card-body p-3 text-center">
                                <div class="mb-2" style="font-size: 2rem;">💰</div>
                                <small class="fw-bold" style="color: var(--dark-color);">Comparte gastos, reduce costos</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Trust & Security Section -->
<section id="tu-eliges-section" class="py-5" style="background: linear-gradient(135deg, #f8fdff 0%, #f0fff4 100%);">
    <div class="container">
        <div class="text-center mb-5">
            <div class="mb-3">
                <span class="badge rounded-pill px-4 py-2" style="background: rgba(82, 220, 183, 0.1); color: var(--primary-color); font-size: 0.9rem; border: 1px solid rgba(82, 220, 183, 0.2);">
                    🛡️ Conoce con quién compartes tu viaje
                </span>
            </div>
            <h2 class="display-5 fw-bold mb-4" style="color: var(--dark-color);">
                Tú eliges con quién viajas,<br>
                <span style="color: var(--primary-color);">nosotros nos encargamos del resto</span>
            </h2>
            <p class="lead mx-auto" style="max-width: 600px; color: var(--dark-color); opacity: 0.8;">
                Seguimiento en tiempo real para tu tranquilidad.
            </p>
        </div>
        
        <div class="row g-4 justify-content-center">
            <div class="col-lg-3 col-md-6">
                <div class="card border-0 h-100 text-center p-4" style="background: rgba(255, 255, 255, 0.8); backdrop-filter: blur(10px); border-radius: 25px; box-shadow: 0 10px 40px rgba(82, 220, 183, 0.1); transition: all 0.3s ease;">
                    <div class="mb-4">
                        <div class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style="width: 80px; height: 80px; background: linear-gradient(135deg, var(--primary-color), var(--secondary-color)); color: white; font-size: 2rem;">
                            🔍
                        </div>
                    </div>
                    <h4 class="fw-bold mb-3" style="color: var(--dark-color);">Información de Conductores y Pasajeros</h4>
                    <p style="color: var(--dark-color); opacity: 0.7; line-height: 1.6;">
                        Para máxima confianza y seguridad te suministramos información del perfil del  conductor o pasajero
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card border-0 h-100 text-center p-4" style="background: rgba(255, 255, 255, 0.8); backdrop-filter: blur(10px); border-radius: 25px; box-shadow: 0 10px 40px rgba(82, 220, 183, 0.1); transition: all 0.3s ease;">
                    <div class="mb-4">
                        <div class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style="width: 80px; height: 80px; background: linear-gradient(135deg, var(--secondary-color), var(--primary-color)); color: white; font-size: 2rem;">
                            📍
                        </div>
                    </div>
                    <h4 class="fw-bold mb-3" style="color: var(--dark-color);">Seguimiento en Tiempo Real</h4>
                    <p style="color: var(--dark-color); opacity: 0.7; line-height: 1.6;">
                        Nos preocupamos por tu bienestar, comparte tu trayecto con tu persona de confianza, para viajes seguros y monitoreados .
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card border-0 h-100 text-center p-4" style="background: rgba(255, 255, 255, 0.8); backdrop-filter: blur(10px); border-radius: 25px; box-shadow: 0 10px 40px rgba(82, 220, 183, 0.1); transition: all 0.3s ease;">
                    <div class="mb-4">
                        <div class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style="width: 80px; height: 80px; background: linear-gradient(135deg, var(--secondary-color), var(--primary-color)); color: white; font-size: 2rem;">
                            ⭐
                        </div>
                    </div>
                    <h4 class="fw-bold mb-3" style="color: var(--dark-color);">Califica y Mejora</h4>
                    <p style="color: var(--dark-color); opacity: 0.7; line-height: 1.6;">
                        Evalúa tu experiencia como conductor y pasajero, ayuda a construir una comunidad de viajeros confiables.
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6">
                <div class="card border-0 h-100 text-center p-4" style="background: rgba(255, 255, 255, 0.8); backdrop-filter: blur(10px); border-radius: 25px; box-shadow: 0 10px 40px rgba(82, 220, 183, 0.1); transition: all 0.3s ease;">
                    <div class="mb-4">
                        <div class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style="width: 80px; height: 80px; background: linear-gradient(135deg, var(--primary-color), var(--secondary-color)); color: white; font-size: 2rem;">
                            🌱
                        </div>
                    </div>
                    <h4 class="fw-bold mb-3" style="color: var(--dark-color);">Cuida el Planeta, Menos CO2</h4>
                    <p style="color: var(--dark-color); opacity: 0.7; line-height: 1.6;">
                        Por cada viaje compartido estás reduciendo CO2, calculamos tu contribución positiva al medio ambiente
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- How It Works Section -->
<section id="como-funciona-section" class="py-5" style="background: white;">
    <div class="container">
        <div class="text-center mb-5">
            <div class="mb-3">
                <span class="badge rounded-pill px-4 py-2" style="background: rgba(82, 220, 183, 0.1); color: var(--primary-color); font-size: 0.9rem; border: 1px solid rgba(82, 220, 183, 0.2);">
                    ⚡ Proceso Simple
                </span>
            </div>
            <h2 class="display-5 fw-bold mb-4" style="color: var(--dark-color);">
                ¿Cómo Funciona <span style="color: var(--primary-color);">RoutiGo</span>?
            </h2>
            <p class="lead mx-auto" style="max-width: 600px; color: var(--dark-color); opacity: 0.8;">
                Conectar personas nunca fue tan fácil y seguro. Solo 4 pasos para transformar tu movilidad.
            </p>
        </div>
        
        <div class="row g-4 justify-content-center">
            <div class="col-12 col-md-6 col-lg-3">
                <div class="card border-0 h-100 text-center p-4 step-card" style="background: linear-gradient(135deg, rgba(82, 220, 183, 0.05), rgba(163, 223, 255, 0.05)); border-radius: 25px; transition: all 0.4s ease; position: relative; overflow: hidden;">
                    <!-- Step Number -->
                    <div class="position-absolute" style="top: -20px; right: -20px; width: 60px; height: 60px; background: linear-gradient(135deg, var(--primary-color), var(--secondary-color)); border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 1.2rem; box-shadow: 0 8px 25px rgba(82, 220, 183, 0.3);">
                        01
                    </div>
                    
                    <div class="mb-4">
                        <div class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style="width: 70px; height: 70px; background: rgba(82, 220, 183, 0.1); color: var(--primary-color); font-size: 2rem;">
                            🔐
                        </div>
                    </div>
                    <h5 class="fw-bold mb-3" style="color: var(--dark-color);">Regístrate y Verifica</h5>
                    <p class="mb-0" style="color: var(--dark-color); opacity: 0.7; line-height: 1.6;">
                       Un perfil completo del conductor o pasajero genera confianza y seguridad.
                    </p>
                </div>
            </div>
            
            <div class="col-12 col-md-6 col-lg-3">
                <div class="card border-0 h-100 text-center p-4 step-card" style="background: linear-gradient(135deg, rgba(163, 223, 255, 0.05), rgba(82, 220, 183, 0.05)); border-radius: 25px; transition: all 0.4s ease; position: relative; overflow: hidden;">
                    <!-- Step Number -->
                    <div class="position-absolute" style="top: -20px; right: -20px; width: 60px; height: 60px; background: linear-gradient(135deg, var(--secondary-color), var(--primary-color)); border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 1.2rem; box-shadow: 0 8px 25px rgba(163, 223, 255, 0.3);">
                        02
                    </div>
                    
                    <div class="mb-4">
                        <div class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style="width: 70px; height: 70px; background: rgba(163, 223, 255, 0.1); color: var(--secondary-color); font-size: 2rem;">
                            🚗
                        </div>
                    </div>
                    <h5 class="fw-bold mb-3" style="color: var(--dark-color);">Publica o busca tu trayecto</h5>
                    <p class="mb-0" style="color: var(--dark-color); opacity: 0.7; line-height: 1.6;">
                         Define tu ruta y los cupos de tu vehículo o busca y escoge tu viaje.
                    </p>
                </div>
            </div>

            <div class="col-12 col-md-6 col-lg-3">
                <div class="card border-0 h-100 text-center p-4 step-card" style="background: linear-gradient(135deg, rgba(163, 223, 255, 0.05), rgba(82, 220, 183, 0.05)); border-radius: 25px; transition: all 0.4s ease; position: relative; overflow: hidden;">
                    <!-- Step Number -->
                    <div class="position-absolute" style="top: -20px; right: -20px; width: 60px; height: 60px; background: linear-gradient(135deg, var(--secondary-color), var(--primary-color)); border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 1.2rem; box-shadow: 0 8px 25px rgba(163, 223, 255, 0.3);">
                        03
                    </div>
                    <div class="mb-4">
                        <div class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style="width: 70px; height: 70px; background: rgba(163, 223, 255, 0.1); color: var(--secondary-color); font-size: 2rem;">
                            💰
                        </div>
                    </div>
                    <h5 class="fw-bold mb-3" style="color: var(--dark-color);">Comparte gastos y reduce costos</h5>
                    <p class="mb-0" style="color: var(--dark-color); opacity: 0.7; line-height: 1.6;">
                        Ahorra dinero de gasolina y peajes compartiendo los cupos de tu vehículo o ahorra dinero en tu trayecto diario.
                    </p>
                </div>
            </div>
            
            <div class="col-12 col-md-6 col-lg-3">
                <div class="card border-0 h-100 text-center p-4 step-card" style="background: linear-gradient(135deg, rgba(82, 220, 183, 0.05), rgba(163, 223, 255, 0.05)); border-radius: 25px; transition: all 0.4s ease; position: relative; overflow: hidden;">
                    <!-- Step Number -->
                    <div class="position-absolute" style="top: -20px; right: -20px; width: 60px; height: 60px; background: linear-gradient(135deg, var(--primary-color), var(--secondary-color)); border-radius: 50%; display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; font-size: 1.2rem; box-shadow: 0 8px 25px rgba(82, 220, 183, 0.3);">
                        04
                    </div>
                    
                    <div class="mb-4">
                        <div class="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" style="width: 70px; height: 70px; background: rgba(82, 220, 183, 0.1); color: var(--primary-color); font-size: 2rem;">
                            🤝
                        </div>
                    </div>
                    <h5 class="fw-bold mb-3" style="color: var(--dark-color);">Conecta y crea comunidad</h5>
                    <p class="mb-0" style="color: var(--dark-color); opacity: 0.7; line-height: 1.6;">
                        Confirma tus usuarios de viaje, seguimiento en línea y notificaciones para que estés a tiempo en el punto de encuentro, Conecta con tus compañeros y viaja con tranquilidad.
                    </p>
                </div>
            </div>
            
        </div>
    </div>
</section>

<!-- Registration Forms Section -->
<section id="footer-subscribe-form" class="py-5" style="background: linear-gradient(135deg, #f8fdff 0%, #f0fff4 100%);">
    <div class="container">
        <div class="text-center mb-5">
            <div class="mb-3">
                <span class="badge rounded-pill px-4 py-2" style="background: rgba(82, 220, 183, 0.1); color: var(--primary-color); font-size: 0.9rem; border: 1px solid rgba(82, 220, 183, 0.2);">
                </span>
            </div>
            <h2 class="display-5 fw-bold mb-4" style="color: var(--dark-color);">
                Comienza tu <span style="color: var(--primary-color);">experiencia RoutiGo</span>
            </h2>
            <!-- <p class="lead mx-auto" style="max-width: 600px; color: var(--dark-color); opacity: 0.8;">
                Regístrate como conductor o pasajero y forma parte de la revolución de la movilidad compartida.
            </p> -->
        </div>
        
        <!-- <div class="row justify-content-center">
            <div class="col-12 col-xl-8"></div>
            <div class="card border-0 shadow-lg" style="background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(20px); border-radius: 30px; overflow: hidden; border: 1px solid rgba(255, 255, 255, 0.2);">
                <div class="p-4 p-lg-5">
                <div class="text-center mb-5">
                    <div class="d-flex align-items-center justify-content-center mb-3">
                    <div class="me-3" style="width: 60px; height: 60px; background: linear-gradient(135deg, var(--primary-color), var(--secondary-color)); border-radius: 20px; display: flex; align-items: center; justify-content: center; color: white; font-size: 2rem;">
                        🚗
                    </div>
                    <h3 class="fw-bold mb-0" style="color: var(--dark-color);">Únete a RoutiGo</h3>
                    </div>
                    <p class="mb-0" style="color: var(--dark-color); opacity: 0.7;">
                    Comparte viajes, ahorra dinero y crea comunidad
                    </p>
                </div>
                
                <div *ngIf="submissionMessage" 
                     class="alert mb-4" 
                     [class.alert-success]="!submissionMessage.includes('Error')"
                     [class.alert-danger]="submissionMessage.includes('Error')"
                     style="border-radius: 15px; border: none;">
                    {{ submissionMessage }}
                </div>
                
                <form [formGroup]="unifiedForm" (ngSubmit)="onFormSubmit($event)" class="modern-form">
                   
                    <div class="mb-4">
                        <label class="form-label fw-bold mb-3" style="color: var(--dark-color);">¿Eres conductor o pasajero?</label>
                        <div class="row g-3">
                            <div class="col-12 col-md-6">
                                <input type="radio" class="btn-check" name="userType" id="conductor" value="conductor" formControlName="userType" autocomplete="off">
                                <label class="btn btn-outline-primary w-100 p-3 text-start user-type-label" for="conductor" style="border-radius: 15px; border: 2px solid rgba(82, 220, 183, 0.3); transition: all 0.3s ease;">
                                    <div class="d-flex align-items-center">
                                        <div class="me-3" style="font-size: 1.5rem;">🚗</div>
                                        <div>
                                            <div class="fw-bold">Soy Conductor</div>
                                            <small class="text-muted">Comparte tu ruta, define los cupos de tu vehículo y comparte gastos</small>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <div class="col-12 col-md-6">
                                <input type="radio" class="btn-check" name="userType" id="pasajero" value="pasajero" formControlName="userType" autocomplete="off">
                                <label class="btn btn-outline-primary w-100 p-3 text-start user-type-label" for="pasajero" style="border-radius: 15px; border: 2px solid rgba(82, 220, 183, 0.3); transition: all 0.3s ease;">
                                    <div class="d-flex align-items-center">
                                        <div class="me-3" style="font-size: 1.5rem;">👥</div>
                                        <div>
                                            <div class="fw-bold">Soy Pasajero</div>
                                            <small class="text-muted">Busca tu trayecto, selecciona tu conductor, espéralo a tiempo en el punto de encuentro y ahorra dinero</small>
                                        </div>
                                    </div>
                                </label>
                            </div>
                            <style>
                            input[name="userType"].btn-check:checked + label.user-type-label {
                                background: #52dcb7 !important;
                                color: #fff !important;
                                border-color: #52dcb7 !important;
                            }
                            input[name="userType"].btn-check:checked + label.user-type-label .text-muted {
                                color: #eafff7 !important;
                            }
                            </style>
                        </div>
                        <div class="invalid-feedback d-block" *ngIf="userType?.invalid && userType?.touched">
                            <small class="text-danger">Debes seleccionar si eres conductor o pasajero.</small>
                        </div>
                    </div>

                    <div class="row g-3 mb-4">
                        <div class="col-12">
                            <label for="fullName" class="form-label">Nombre Completo *</label>
                            <input 
                                type="text" 
                                class="form-control modern-input" 
                                id="fullName" 
                                placeholder="Ingresa tu nombre completo"
                                autocomplete="name"
                                formControlName="fullName"
                                [class.is-invalid]="fullName?.invalid && fullName?.touched"
                                [class.is-valid]="fullName?.valid && fullName?.touched">
                            <div class="invalid-feedback" *ngIf="fullName?.invalid && fullName?.touched">
                                <div *ngIf="fullName?.errors?.['required']">El nombre completo es obligatorio.</div>
                                <div *ngIf="fullName?.errors?.['minlength']">El nombre debe tener al menos 2 caracteres.</div>
                                <div *ngIf="fullName?.errors?.['maxlength']">El nombre no puede exceder 50 caracteres.</div>
                                <div *ngIf="fullName?.errors?.['pattern']">El nombre solo puede contener letras y espacios.</div>
                            </div>
                        </div>
                        
                        <div class="col-12">
                            <label for="email" class="form-label">Correo Electrónico *</label>
                            <input 
                                type="email" 
                                class="form-control modern-input" 
                                id="email" 
                                placeholder="correo@ejemplo.com"
                                autocomplete="email"
                                formControlName="email"
                                [class.is-invalid]="email?.invalid && email?.touched"
                                [class.is-valid]="email?.valid && email?.touched">
                            <div class="invalid-feedback" *ngIf="email?.invalid && email?.touched">
                                <div *ngIf="email?.errors?.['required']">El correo electrónico es obligatorio.</div>
                                <div *ngIf="email?.errors?.['email'] || email?.errors?.['pattern']">Por favor ingresa un correo electrónico válido.</div>
                            </div>
                        </div>
                        
                        <div class="col-12">
                            <label for="phone" class="form-label">Número de Celular *</label>
                            <input 
                                type="tel" 
                                class="form-control modern-input" 
                                id="phone" 
                                placeholder="Número de celular"
                                autocomplete="tel"
                                formControlName="phone"
                                [class.is-invalid]="phone?.invalid && phone?.touched"
                                [class.is-valid]="phone?.valid && phone?.touched">
                            <div class="invalid-feedback" *ngIf="phone?.invalid && phone?.touched">
                                <div *ngIf="phone?.errors?.['required']">El número de celular es obligatorio.</div>
                                <div *ngIf="phone?.errors?.['pattern']">El número debe contener entre 7 y 15 dígitos.</div>
                            </div>
                        </div>
                    </div>

                    <div class="mb-4">
                        <label for="tripPurpose" class="form-label fw-bold">¿Mi trayecto es para? *</label>
                        <select 
                            class="form-select modern-input" 
                            id="tripPurpose"
                            formControlName="tripPurpose"
                            [class.is-invalid]="tripPurpose?.invalid && tripPurpose?.touched"
                            [class.is-valid]="tripPurpose?.valid && tripPurpose?.touched">
                            <option value="" disabled>Selecciona una opción</option>
                            <option value="Trabajo">Ir al trabajo</option>
                            <option value="Universidad">Universidad</option>
                            <option value="Eventos">Eventos</option>
                            <option value="Otro">Otro</option>
                        </select>
                        <div class="invalid-feedback" *ngIf="tripPurpose?.invalid && tripPurpose?.touched">
                            Debes seleccionar el propósito de tu trayecto.
                        </div>
                    </div>

                    <div class="mb-4">
                        <label class="form-label fw-bold mb-3" style="color: var(--dark-color);">¿Cuál es tu ruta cotidiana?</label>
                        <div class="row g-3">
                            <div class="col-12 col-md-6">
                                <label for="origin" class="form-label">Origen *</label>
                                <input 
                                    type="text" 
                                    class="form-control modern-input" 
                                    id="origin" 
                                    placeholder="Punto de origen"
                                    formControlName="origin"
                                    [class.is-invalid]="origin?.invalid && origin?.touched"
                                    [class.is-valid]="origin?.valid && origin?.touched">
                                <div class="invalid-feedback" *ngIf="origin?.invalid && origin?.touched">
                                    <div *ngIf="origin?.errors?.['required']">El punto de origen es obligatorio.</div>
                                    <div *ngIf="origin?.errors?.['maxlength']">El origen no puede exceder 100 caracteres.</div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <label for="destination" class="form-label">Destino *</label>
                                <input 
                                    type="text" 
                                    class="form-control modern-input" 
                                    id="destination" 
                                    placeholder="Punto de destino"
                                    formControlName="destination"
                                    [class.is-invalid]="destination?.invalid && destination?.touched"
                                    [class.is-valid]="destination?.valid && destination?.touched">
                                <div class="invalid-feedback" *ngIf="destination?.invalid && destination?.touched">
                                    <div *ngIf="destination?.errors?.['required']">El punto de destino es obligatorio.</div>
                                    <div *ngIf="destination?.errors?.['maxlength']">El destino no puede exceder 100 caracteres.</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mb-4 text-center">
                        <div class="captcha-container p-3" style="background: rgba(82, 220, 183, 0.05); border-radius: 15px; border: 2px solid rgba(82, 220, 183, 0.2);">
                            <div class="mb-3">
                                <span class="fw-bold" style="color: var(--dark-color);">Verificación: </span>
                                <span class="captcha-text p-2 rounded" style="background: white; font-family: monospace; font-size: 1.2rem; letter-spacing: 3px; color: var(--dark-color); border: 1px solid #ddd;">
                                    {{ captchaText }}
                                </span>
                                <button type="button" class="btn btn-sm btn-outline-secondary ms-2" (click)="generateCaptcha()" style="border-radius: 10px;">
                                    🔄
                                </button>
                            </div>
                            <div style="max-width: 200px; margin: 0 auto;">
                                <label for="captcha" class="form-label">Código de verificación *</label>
                                <input 
                                    type="text" 
                                    class="form-control modern-input text-center" 
                                    id="captcha" 
                                    placeholder="Ingresa el código"
                                    formControlName="captcha"
                                    [class.is-invalid]="captcha?.invalid && captcha?.touched"
                                    [class.is-valid]="captcha?.valid && captcha?.touched">
                                <div class="invalid-feedback" *ngIf="captcha?.invalid && captcha?.touched">
                                    <div *ngIf="captcha?.errors?.['required']">El código de verificación es obligatorio.</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mb-4">
                        <div class="form-check d-flex align-items-start">
                            <input 
                                class="form-check-input mt-1 me-3" 
                                type="checkbox" 
                                id="dataConsent"
                                formControlName="dataConsent"
                                [class.is-invalid]="dataConsent?.invalid && dataConsent?.touched">
                            <label class="form-check-label small" for="dataConsent" style="line-height: 1.5;">
                               
                                <a href="#" class="text-primary" (click)="showDataPolicyModal(); $event.preventDefault()" style="text-decoration: none;">
                                    Autorizo el uso de mis datos personales
                                </a>
                            </label>
                            <div class="invalid-feedback d-block" *ngIf="dataConsent?.invalid && dataConsent?.touched">
                                <small class="text-danger">Debes aceptar la política de tratamiento de datos.</small>
                            </div>
                        </div>
                    </div>
                    
                    <button 
                        type="submit" 
                        class="btn btn-modern w-100 py-3 fw-bold"
                        [disabled]="isSubmitting || unifiedForm.invalid || captcha?.value !== captchaText"
                        style="background: linear-gradient(135deg, var(--primary-color), var(--secondary-color)); border: none; border-radius: 15px; color: white; font-size: 1.1rem; transition: all 0.3s ease; box-shadow: 0 8px 25px rgba(82, 220, 183, 0.3);">
                        <span *ngIf="!isSubmitting">🚀 Unirme a RoutiGo</span>
                        <span *ngIf="isSubmitting">
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Enviando...
                        </span>
                    </button>
                </form>
                </div>
            </div>
            </div>-->
        </div> 

        <!-- Data Policy Modal -->
        <div class="modal fade" id="dataPolicyModal" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
            <div class="modal-content" style="border-radius: 20px; border: none;">
                <div class="modal-header" style="background: linear-gradient(135deg, var(--primary-color), var(--secondary-color)); color: white; border-radius: 20px 20px 0 0;">
                <h5 class="modal-title fw-bold">Política de Tratamiento de Datos Personales</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body p-4">
                <h6 class="fw-bold mb-3">Finalidad del Tratamiento de Datos</h6>
                <p>RoutiGo recolecta y trata tus datos personales con las siguientes finalidades:</p>
                <ul>
                    <li>Crear y gestionar tu perfil de usuario en la plataforma</li>
                    <li>Facilitar la conexión entre conductores y pasajeros</li>
                    <li>Procesar y gestionar solicitudes de viajes compartidos</li>
                    <li>Enviar notificaciones relacionadas con tus viajes</li>
                    <li>Mejorar la seguridad y confianza en la plataforma</li>
                    <li>Cumplir con obligaciones legales y contractuales</li>
                    <li>Realizar análisis estadísticos para mejorar nuestros servicios</li>
                </ul>
                
                <h6 class="fw-bold mb-3 mt-4">Derechos del Titular</h6>
                <p>Como titular de los datos, tienes derecho a:</p>
                <ul>
                    <li>Conocer, actualizar y rectificar tus datos personales</li>
                    <li>Solicitar prueba de la autorización otorgada</li>
                    <li>Ser informado sobre el uso dado a tus datos</li>
                    <li>Presentar quejas ante la Superintendencia de Industria y Comercio</li>
                    <li>Revocar la autorización y/o solicitar la supresión de datos</li>
                    <li>Acceder de forma gratuita a tus datos personales</li>
                </ul>
                
                <h6 class="fw-bold mb-3 mt-4">Contacto</h6>
                <p>Para ejercer tus derechos o presentar consultas, puedes contactarnos en:</p>
                <p><strong>Email:</strong> datos&#64;routigo.com<br>
                <strong>Dirección:</strong> [Dirección de RoutiGo]</p>
                </div>
                <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" style="border-radius: 10px;">Cerrar</button>
                </div>
            </div>
            </div>
        </div>
</section>

<!-- Modern Animations and Styles -->
<style>
/* Floating animations */
@keyframes float {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    33% { transform: translateY(-20px) rotate(1deg); }
    66% { transform: translateY(-10px) rotate(-1deg); }
}

@keyframes phoneFloat {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-15px); }
}

/* Hero section hover effects */
.app-badge:hover {
    transform: scale(1.05);
}

/* Button hover effects */
.btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(82, 220, 183, 0.4) !important;
}

/* Card hover effects */
.step-card:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 0 20px 60px rgba(82, 220, 183, 0.15) !important;
}

/* Modern form inputs */
.modern-input {
    border-radius: 15px !important;
    border: 2px solid rgba(82, 220, 183, 0.2) !important;
    background: rgba(255, 255, 255, 0.9) !important;
    font-size: 1rem;
    padding: 0.75rem 1rem !important;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    box-shadow: 0 4px 15px rgba(82, 220, 183, 0.05);
}

.modern-input:focus {
    border-color: var(--primary-color) !important;
    box-shadow: 0 0 0 3px rgba(82, 220, 183, 0.15), 0 8px 25px rgba(82, 220, 183, 0.1) !important;
    background: rgba(255, 255, 255, 1) !important;
    transform: translateY(-2px);
}

.form-floating > .modern-input:focus ~ label,
.form-floating > .modern-input:not(:placeholder-shown) ~ label {
    color: var(--primary-color) !important;
    font-weight: 600;
}

/* Trust cards hover effect */
section .card:hover {
    transform: translateY(-8px) scale(1.03);
    box-shadow: 0 20px 60px rgba(82, 220, 183, 0.2) !important;
}

/* Responsive design improvements */
@media (max-width: 768px) {
    .floating-shape {
        display: none;
    }
    
    .position-absolute[style*="top: 20%; left: -60px"],
    .position-absolute[style*="bottom: 30%; right: -50px"] {
        display: none !important;
    }
}

/* Glassmorphism effect enhancement */
.card[style*="backdrop-filter"] {
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

/* Loading spinner enhancement */
.spinner-border-sm {
    width: 1rem;
    height: 1rem;
}
</style>